document.addEventListener("DOMContentLoaded", async () => {
    await handleViewProduct();
    await handleAddToCart();
});

interface GtagViewItemEvent {
    items: {
        id: BigInteger;
        name: string;
        permalink: string;
        category: string[];
        quantity: BigInteger;
        price: Number;
        currency: string;
    }[];
}

const handleViewProduct = async () => {

    const item = window.product_data;

    if (!item) {
        return;
    }

    const gtagData: GtagViewItemEvent = {
        items: [
            {
                id: item.id,
                name: item.name,
                permalink: item.permalink,
                category: item.category,
                quantity: item.quantity,
                price: item.price,
                currency: item.currency,
            },
        ],
    };

    gtag('event', 'view_item', gtagData);
    console.log(gtagData);
};

const handleAddToCart = async () => {
    const item = window.product_data;

    if (!item) {
        return;
    }

    window.addEventListener('click', (e) => {
        const target = e.target as HTMLElement;

        if (target.classList.contains('add_to_cart_button') || target.classList.contains('single_add_to_cart_button')) {
            const quantity = document.querySelector<HTMLInputElement>('input[name="quantity"]');
            if (!quantity) return;
            const price = document.querySelector<HTMLElement>('#product-price')
                ?
                document.querySelector<HTMLElement>('#product-price')
                :
                document.querySelector<HTMLElement>('.woocommerce-Price-amount bdi');

            if (!price) return;

            const priceNumber = parseFloat(price.innerText.replace(",", ".")) as Number;
            const quantityNumber = parseInt(quantity.value) as BigInteger;

            const gtagData: GtagViewItemEvent = {
                items: [
                    {
                        id: item.id,
                        name: item.name,
                        permalink: item.permalink,
                        category: item.category,
                        quantity: quantityNumber,
                        price: priceNumber,
                        currency: item.currency,
                    },
                ],
            };

            gtag('event', 'add_to_cart', gtagData);
            console.log(gtagData);
        }
    })
}